export default __webpack_public_path__ + "static/media/default.295314bd.png";